var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { fetchSharedContext } from '@office-start/context-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { fetchDriveItem } from '@office-start/graph-service';
import { logError, logFeature } from '@office-start/telemetry-service';
import { appendQueryParam, getQueryParams, } from '@office-start/url-parser-utility';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { FluidContentPage } from '../FluidContentPage/FluidContentPage';
export var ContentPage = function () {
    var _a;
    var app = useParams().app;
    var featureGates = useFeatureGates().data;
    var componentContext = useOfficeComponentContext().data;
    var queryParams = useMemo(function () {
        return getQueryParams(location.search);
    }, []);
    var isLoopRedirectEnabled = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.fluidRedirectLoopGates) === null || _a === void 0 ? void 0 : _a.fluidRedirectLoopEnabled;
    useEffect(function () {
        if (!isLoopRedirectEnabled ||
            (app === null || app === void 0 ? void 0 : app.toLowerCase()) !== 'fluid' ||
            !componentContext) {
            return;
        }
        if (!queryParams.item || !queryParams.drive) {
            logError({
                eventName: 'Fluid_Redirect_Error',
                message: 'Missing query parameters',
            });
            return;
        }
        var getSharepointUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
            var sharedContext, driveItem, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchSharedContext()];
                    case 1:
                        sharedContext = _a.sent();
                        if (!sharedContext) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, fetchDriveItem({
                                itemId: queryParams.item,
                                driveId: queryParams.drive,
                                graphXhrOptions: {
                                    correlationId: componentContext.correlationId,
                                    getAccessToken: componentContext.getAccessToken,
                                    jwtAuthEnabled: componentContext.jwtAuthEnabled,
                                    officeApiRoot: componentContext.officeHomeApiRoot,
                                    graphApiRoot: sharedContext.graphApiRoot,
                                },
                                queryParams: {
                                    select: 'webUrl',
                                },
                            })];
                    case 3:
                        driveItem = _a.sent();
                        logFeature({
                            featureName: "FluidRedirectLoop" /* KnownFeatureNames.FluidRedirectLoop */,
                            eventName: 'Fluid_Redirect',
                        });
                        window.location.href = appendQueryParam(driveItem.webUrl, 'web', '1');
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        logError({
                            eventName: 'Fluid_Redirect_Error',
                            message: error_1 || 'File not found',
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        getSharepointUrl();
    }, [
        app,
        componentContext,
        isLoopRedirectEnabled,
        queryParams.drive,
        queryParams.item,
    ]);
    if ((app === null || app === void 0 ? void 0 : app.toLowerCase()) === 'fluid' && !isLoopRedirectEnabled) {
        return React.createElement(FluidContentPage, null);
    }
    return null;
};
//# sourceMappingURL=ContentPage.js.map